export const injectionMoldingAccionesRoles = {
  sharedActions: {
    scheduler: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
      'InjectionMoldingOperator',
      'InjectionMoldingLeader',
    ],
    molds: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
      'InjectionMoldingLeader',
    ],
    validation: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
      'InjectionMoldingLeader',
    ],
    planning: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
    ],
    addQcData: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
      'QualityControl',
    ],
    qcRejected: [
      'Admin',
      'Chief',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingSupervisor',
      'InjectionMoldingLeader'
    ],
    qualityControl: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
      'QualityControl',
      'InjectionMoldingQc',
      'QualityControlInspector',
    ],
    packingBox: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'InjectionMoldingLabel',
    ],
  },

  routerActions: {
    // No hay rutas exclusivas del Router
  },

  sideNavActions: {
    reportsPbiInjectionMolding: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
      'InjectionMoldingOperator',
      'InjectionMoldingLeader',
      'InjectionMoldingQc',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'InjectionMoldingLabel',
    ],
    root: [
      'Chief',
      'Admin',
      'Viewer',
      'InjectionMoldingAdmin',
      'InjectionMoldingChief',
      'InjectionMoldingViewer',
      'InjectionMoldingSupervisor',
      'InjectionMoldingOperator',
      'InjectionMoldingLeader',
      'InjectionMoldingQc',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'InjectionMoldingLabel',
    ],
  },
};
